import { render, staticRenderFns } from "./GenericAlertBox.vue?vue&type=template&id=3650b674&scoped=true"
import script from "./GenericAlertBox.vue?vue&type=script&lang=js"
export * from "./GenericAlertBox.vue?vue&type=script&lang=js"
import style0 from "./GenericAlertBox.vue?vue&type=style&index=0&id=3650b674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650b674",
  null
  
)

export default component.exports